import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Penyedia } from './state';
import { App } from './App';
import './style.css';

createRoot(document.getElementById('akar')!).render(
  <StrictMode>
    <Penyedia>
      <App />
    </Penyedia>
  </StrictMode>,
);
